import { useUserStore } from '~/stores';

class Guest implements Middleware {
    name() {
        return 'guest';
    }

    async run() {
        const userStore = useUserStore();
        if (!userStore.loggedIn) return;

        return {
            name: 'index',
        };
    }
}

export default new Guest();
